import React from "react";
import PropTypes from "prop-types";
import HPOTree from "../atoms/HPOTree";
import PathogenicityPill from "../atoms/PathogenicityPill";
import SSOUser from "./SSOUser";
import Contribution from "../../models/Contribution";
import Linkify from "../atoms/Linkify";
import conf from "./linkifyConf";
import TimeSince from "./TimeSince";
import Btn from "../atoms/Btn";

function ContributionItem({ contribution }) {
  const { diseases, phenotypes } = contribution || {};
  const [showTree, setShowTree] = React.useState(false);
  const disAndPheno = diseases.concat(phenotypes);

  return (
    <div className="tw-p-1">
      <div className="tw-flex tw-items-center ">
        <div data-tab="none" className="tw-inline-block">
          <SSOUser
            ssoId={contribution.user.ssoId}
            defaultName={contribution.user.fullName}
            isCoAuthor={contribution.coAuthor}
            isSaphetorCuratorLinked={contribution.isSaphetorCuratorLinked}
          />
        </div>
        <div className="tw-mx-2 tw-flex-shrink-0">&bull;</div>
        <TimeSince date={contribution.createdAt} />
      </div>

      <div className="tw-text-blueGray-600 tw-pt-1">
        {contribution.pathogenicity ? (
          <div className="tw-flex tw-text-xs">
            <div className="tw-w-36 tw-font-bold tw-flex-shrink-0">
              Classification
            </div>
            <span className="tw-px-1">
              <div className="tw-not-italic text-smaller-1 tw-font-bold">
                <PathogenicityPill
                  withPlainBackground={false}
                  pathogenicity={contribution.pathogenicity}
                />
              </div>
            </span>
          </div>
        ) : null}
        {contribution.additionalInfo?.length ? (
          <div className="tw-flex tw-text-xs">
            <div className="tw-w-36 tw-font-bold tw-flex-shrink-0">
              Variant Information
            </div>
            <span className="tw-px-1">
              {contribution.additionalInfo.join(",  ")}
            </span>
          </div>
        ) : null}

        {contribution.comment ? (
          <div className="tw-flex tw-text-xs">
            <div className="tw-w-36 tw-font-bold tw-flex-shrink-0">
              User Comment
            </div>
            <span className="tw-px-1">
              <div className="tw-text-xs tw-whitespace-pre-wrap tw-break-all">
                <Linkify text={contribution.comment} conf={conf} />
              </div>
            </span>
          </div>
        ) : null}
        {disAndPheno?.length ? (
          <div className="tw-flex tw-text-xs">
            <div className=" tw-w-36 tw-font-bold tw-flex-shrink-0">
              Diseases & Phenotypes
            </div>
            <div className="tw-px-1">
              {disAndPheno.map((x, i) => (
                <div
                  key={x.disease_id || x.phenotype_id || x.id || i}
                  className="tw-mr-2 tw-inline-block tw-underline"
                >
                  {x.disease_name || x.phenotype_name || x.name}
                </div>
              ))}
              <div data-tab="none" className="tw-inline-block">
                <Btn
                  className="tw-text-primary tw-px-4"
                  onSubmit={() => setShowTree(!showTree)}
                >{`${showTree ? "Hide" : "Show"} phenotype list`}</Btn>
              </div>
            </div>
          </div>
        ) : null}
      </div>

      {showTree ? (
        <div className="tw-text-sm tw-py-1">
          <HPOTree
            hideInfo={true}
            HPOTree={{ hpo: [{ diseases, phenotypes }] }}
          />
        </div>
      ) : null}
    </div>
  );
}

ContributionItem.propTypes = {
  contribution: PropTypes.instanceOf(Contribution),
};

ContributionItem.defaultProps = {
  contribution: {},
};

export default React.memo(ContributionItem);
